import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AmpButton from "../../common/AmpButton/AmpButton";
import { Link } from "react-router-dom";
import { FormRegTabs } from "../RegistrationTypes";
import { EnotificationPayload } from "../../../redux/actions/auth/reg";
import AttestText from "./AttestText";
import AmpFormError from "../../common/AmpFormError/AmpFormError";
import EnoticiationForm, { AcceptFormError, defaultErrors, EnotifFormData } from "../../account/EnotificationForm/EnotificationForm";

interface AttestProps extends FormRegTabs {
    registerUserEvent: (newPayload: EnotificationPayload) => void;
}

export default function AttestationEnotificationAccept(props: AttestProps) {

    const { t } = useTranslation("login");

    // Email State
    const [attestValid, setAttestValid] = useState(false);
    const [consented, setConsented] = useState(false);
    const [errors, setErrors] = useState<AcceptFormError>({
        ...defaultErrors
    })
    const [updateKey, setUpdateKey] = useState(0);

    const validateForm = (formData: EnotifFormData) => {

        const newErrors = defaultErrors;
        newErrors.checkboxError = !consented;
        // Early Return
        if (newErrors.checkboxError || newErrors.nameError || newErrors.phoneError) {
            setAttestValid(false);
            setErrors(newErrors);
            return;
        }
        setErrors(newErrors);

        const enotificationPayload: EnotificationPayload = {
            enabled: true,
            firstname: formData.firstname,
            lastname: formData.lastname,
            phone: formData.phone
        }
        const payload = { ...props.payload };
        payload.enotif = enotificationPayload;
        props.setPayload(payload);
        setAttestValid(true);
        console.log(payload);
        setTimeout(() => {
            props.registerUserEvent(payload)
        }, 500)
        
    };

    const reset = () => {
        setAttestValid(false);
    }

    const handleConsent = (checked: boolean) => {
        setConsented(checked);
        const newErrors = { ...errors }
        newErrors.checkboxError = !checked;
        setErrors(newErrors);
    }
    
    return (
        <>
            <div className="dark-blue-background">
                <h2>{t('6-top-text') as string}</h2>
            </div>
            <div className="login-container-mid">
                <AttestText isEnabled={true} handleConsent={handleConsent}/>
                <AmpFormError errorMessage={t("consent-error")} error={errors.checkboxError} />
                <EnoticiationForm
                    updateKey={updateKey}
                    resetCallback={() => reset()}
                    disabled={false}
                    formCallback={validateForm}
                    backButtonEnabled={false}
                    attestValid={attestValid}
                    setAttestValid={setAttestValid}
                />
            </div>

            <div className="login-container-footer">
                <Link rel="noreferrer noopener" target="_blank" className="amp-anchor" to="/auth/contact-us">{t("need-help") as string}</Link>
                <div>
                    <AmpButton type="cancel" onClick={() => props.triggerCancel(true)} text={t("cancel")} />
                    <AmpButton type="cancel" onClick={() => { reset(); props.setActiveTab(4) }} text={t("back")} />
                    <AmpButton type="submit" onClick={() => setUpdateKey(updateKey+1)} text={t("4-create")} disabled={!consented} />
                </div>
            </div>
        </>
    )
}